<template>
  <v-container>
    <title>aha!</title>
    <v-card>
    <v-layout row>
      <v-flex xs12 sm6 offset-sm3 class="cardtop">
        <h4>Create an new Discussion</h4>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs12>
        <form @submit.prevent="onCreateMeetup">
          <v-layout row>
            <v-flex xs12 sm6 offset-sm3>
              <v-text-field
                name="title"
                label="Title"
                outline
                id="title"
                v-model="title"
                required>
                </v-text-field>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12 sm6 offset-sm3>
              <v-select
                :items="Type"
                :rules="[v => !!v || 'Item is required']"
                box
                label="Type"
                id="Type"
                v-model="Type"
                required></v-select>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12 sm6 offset-sm3>
            <v-btn raised type="primary" @click="onPickFile">uploadimages</v-btn>
            <input type="file" style="display: none" 
            ref="fileinput" 
            accept="image/*"
            @change="onfilechoose">
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12 sm6 offset-sm3>
              <img :src="imageUrl" height="150">
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12 sm6 offset-sm3>
              <v-textarea
                name="description"
                label="Description"
                id="description"
                box
                multi-line
                v-model="description"
                required></v-textarea>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12 sm6 offset-sm3>
              <h4>Choose a Date & Time(Date will be generated auto)</h4>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12 sm6 offset-sm3>
              <v-time-picker v-model="time" format="24hr"></v-time-picker>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex xs12 sm6 offset-sm3 class="cardbottom">
              <v-btn
                class="primary"
                :disabled="!formIsValid"
                type="submit">Create now</v-btn>
            </v-flex>
          </v-layout>
        </form>
      </v-flex>
    </v-layout>
    </v-card>
  </v-container>
</template>

<script>
/* eslint-disable */
  export default {
    data () {
      return {
        title: '',
        imageUrl: '',
        description: '',
        date: new Date(),
        time: new Date(),
        image: null,
        select: null,
        Type: [
        'OnlineGame',
        'Match',
        'Tool',
        'AboutVideo'
      ],
      }
    },
    computed: {
      formIsValid () {
        return this.title !== '' &&
          this.Type !== '' &&
          this.imageUrl !== '' &&
          this.description !== ''
      },
      submittableDateTime () {
        const date = new Date(this.date)
        if (typeof this.time === 'string') {
          let hours = this.time.match(/^(\d+)/)[1]
          const minutes = this.time.match(/:(\d+)/)[1]
          date.setHours(hours)
          date.setMinutes(minutes)
        } else {
          date.setHours(this.time.getHours())
          date.setMinutes(this.time.getMinutes())
        }
        return date
      }
    },
    methods: {
      onCreateMeetup () {
        if (!this.formIsValid) {
          return
        }
        if (!this.image){
        return 
        }
        const meetupData = {
          title: this.title,
          Type: this.Type,
          image: this.image,
          description: this.description,
          date: this.submittableDateTime
        }
        this.$store.dispatch('createMeetup', meetupData)
        this.$router.push('/meetups')
      },
      onPickFile() {
      this.$refs.fileinput.click()
      },
      onfilechoose (event) {
      const files = event.target.files
      let filename = files[0].name;
      if (filename.lastIndexOf('.') <= 0){
      return alert('please use valid file!')
      }
      const fileReader = new FileReader()
      fileReader.addEventListener('load', () => {
      this.imageUrl = fileReader.result
      })
      fileReader.readAsDataURL(files[0])
      this.image = files[0]
      }
    }
  }
</script>

<style>
.cardtop{
  margin-top: 30px;
}
.cardbottom{
  margin-top: 30px;
margin-bottom: 30px;
}
</style>
